/*

  Course Content Widget
  This is a widget that can be applied on any page that will open an application that 
  allows users to organize content within the course.

  Events:
  - CourseContentAdded(content): Course content has been added.
  - CourseContentRemoved(content): Course content has been removed.
  - CourseContentModified(content): Course content has been modified.

  Options:
  - event: The event on the element that triggers the opening of the course content widget. (default: click)

  Basic Usage:
  CourseContentWidget.apply(selector[, options])

  Example:
  JS.require('CourseContentWidget', function() {
      $(document).ready(function() {
          CourseContentWidget.apply('#openCourseContentWidgetButton');
      }
  }

  Events Example:
  JS.require('CourseContentWidget', function() {
      $(document).ready(function() {
          CourseContentWidget.apply('#openCourseContentWidgetButton');
          $(window).on('CourseContentAdded', function(content) {
              console.log('Hey cool, ' + content.title + ' was just added!');
          });
      }
  }
 */
var CourseContentWidget = new JS.Class({
  extend: {
    apply: function(selector, options) {
      return new this(selector, options);
    },
  },
  options: {
    constants: {
      MEDIA_URL: '',
    },
    event: 'click',
  },
  cache: {},
  initialize: function(selector, options) {
    $.extend(this.options, options);
    var widget = this;

    $.ajaxSetup({ cache: false });
    $.getScript(
      widget.options.constants.MEDIA_URL +
        'lib/dust/compiled_templates/courseContentWidget.dust'
    ).done(function() {
      var $initButton;
      if (selector instanceof jQuery) {
        $initButton = selector;
      } else {
        $initButton = $(selector);
      }

      if ($initButton.length) {
        $initButton.on(widget.options.event, widget.openWidget);
      } else {
        $('body').on(widget.options.event, selector, widget.openWidget);
      }

      dust.render('courseContentWidget', {}, function(error, html) {
        $('body').append(html);
      });
    });
  },
  openWidget: function() {
    $('#courseContentModal').modal('show');
  },
});
